/* eslint-disable no-shadow,no-param-reassign */
import _ from "lodash";

const initialState = {
  newScheduled: {
    nuw: [],
    scheduled: []
  },
  popularTimes: []
};

export const state = initialState;

export const getters = {
  newScheduled: state => state.newScheduled,
  newTotal: state =>
    _.reduce(
      state.newScheduled.nuw.map(stat => stat.count),
      (sum, n) => sum + n
    ),
  scheduledTotal: state =>
    _.reduce(
      state.newScheduled.scheduled.map(stat => stat.count),
      (sum, n) => sum + n
    ),
  popularTimes: state => state.popularTimes
};

export const actions = {
  set({ commit }, payload) {
    commit("set", payload);
  },
  setPopularTimes({ commit }, payload) {
    commit("setPopularTimes", payload);
  }
};

export const mutations = {
  set(state, stats) {
    state.newScheduled = stats;
  },
  setPopularTimes(state, stats) {
    state.popularTimes = stats;
  }
};
